import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrackIcon, RefreshCwIcon, EyeOffIcon, ScaleIcon, HomeIcon, BrainIcon, ClockIcon, UserIcon, HeartIcon, SparklesIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function PainIdentificationSection() {
  const checklist = [{
    text: 'Sigues en pareja, pero te sientes profundamente sola.',
    icon: HeartCrackIcon
  }, {
    text: 'Sientes que algo entre ustedes cambió, aunque no sepas explicarlo bien.',
    icon: RefreshCwIcon
  }, {
    text: 'Ya no te sientes elegida, mirada ni emocionalmente acompañada.',
    icon: EyeOffIcon
  }, {
    text: 'Sientes que tú cargas sola con el peso emocional de la relación.',
    icon: ScaleIcon
  }, {
    text: 'No quieres destruir tu familia, pero tampoco quieres seguir desapareciendo dentro de ella.',
    icon: HomeIcon
  }, {
    text: 'No quieres reaccionar por impulso. Quieres entender qué está pasando.',
    icon: BrainIcon
  }, {
    text: 'Te da miedo descubrir que ya no hay vuelta atrás.',
    icon: ClockIcon
  }, {
    text: 'Ya no soportas vivir como espectadora de tu propia vida.',
    icon: UserIcon
  }];
  return <section className="py-8 md:py-12 px-6 bg-[#F8E8EE]" data-id="element-164">
      <div className="max-w-3xl mx-auto" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-167">
            TODO PARECE NORMAL… PERO TÚ SABES QUE NO
          </h2>

          <div className="space-y-4 text-lg text-mutedBrown leading-relaxed" data-id="element-168">
            <p data-id="element-169">
              Siguen juntos. Siguen cumpliendo. Siguen resolviendo. Siguen
              siendo familia.
            </p>
            <p data-id="element-170">Pero por dentro, algo cambió.</p>
            <p data-id="element-171">
              Ya no te sientes igual. Ya no te sientes mirada. Ya no te sientes
              elegida. Ya no te sientes acompañada de verdad.
            </p>
            <p data-id="element-172">Y lo más difícil de explicar es esto:</p>

            <blockquote className="border-l-4 border-softGold pl-6 py-2 my-6 text-2xl md:text-3xl font-heading italic text-warmBrown" data-id="element-173">
              Estoy sola aunque él está aquí.
            </blockquote>

            <p data-id="element-174">
              No estás sola por no tener pareja. Estás sola dentro de una
              relación que ya no te abraza emocionalmente.
            </p>
          </div>

          <div className="mt-8" data-id="element-175">
            <CTAButton text="QUIERO DEJAR DE SUFRIR EN SILENCIO" icon={<HeartIcon className="w-5 h-5" data-id="element-177" />} data-id="element-176" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-10" data-id="element-178">
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-179">
            ESTA GUÍA ES PARA TI SI…
          </h3>

          <ul className="space-y-4 mb-8" data-id="element-180">
            {checklist.map((item, index) => {
            const Icon = item.icon;
            return <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-181">
                  <Icon className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-182" />
                  <span className="text-lg text-warmBrown" data-id="element-183">{item.text}</span>
                </motion.li>;
          })}
          </ul>

          <CTAButton text="QUIERO RECUPERAR CLARIDAD" icon={<SparklesIcon className="w-5 h-5" data-id="element-185" />} data-id="element-184" />
        </motion.div>
      </div>
    </section>;
}